import React from 'react';
import PropTypes from 'prop-types';
import EmptyList from './presentation/EmptyList';
import ExplorerItem from './presentation/ExplorerItem';
import ExplorerList from './presentation/ExplorerList';
import DataProcessor from './smart/DataProcessor';
import { TreeViewProvider } from '../../context/TreeViewProvider';
const Explorer = _ref => {
  let {
    treeNodes = [],
    onExpand = () => {},
    onSelect = () => {},
    expandedKeys = [],
    selectedKeys = [],
    groupTitle = 'Folders',
    entityTitle = 'Files',
    baseLabel = 'Back',
    loading = false,
    emptyListCallback,
    close = () => {},
    navigatorBar = {},
    infiniteLoading: {
      loading: infLoading = false,
      ids: infLoadingIds = [],
      levels = [],
      loadMore = null,
      observerOptions = {}
    } = {}
  } = _ref;
  if (!(Array.isArray(treeNodes) && treeNodes.length) && !loading) {
    return /*#__PURE__*/React.createElement(EmptyList, {
      emptyListCallback: emptyListCallback
    });
  }
  return /*#__PURE__*/React.createElement(TreeViewProvider, {
    treeNodes: treeNodes,
    expandedKeys: expandedKeys,
    selectedKeys: selectedKeys
  }, /*#__PURE__*/React.createElement(DataProcessor, {
    treeNodes: treeNodes,
    baseLabel: baseLabel,
    loading: loading,
    levels: levels,
    infLoadingIds: infLoadingIds
  }, /*#__PURE__*/React.createElement(ExplorerList, {
    groupTitle: groupTitle,
    entityTitle: entityTitle,
    navigatorBar: navigatorBar,
    infLoading: infLoading,
    loadMore: loadMore,
    observerOptions: observerOptions,
    emptyListCallback: emptyListCallback
  }, (i, _ref2) => {
    let {
      treeNode,
      hashTable,
      expanded,
      selected,
      setExpanded,
      setSelected,
      measureRef
    } = _ref2;
    return /*#__PURE__*/React.createElement(ExplorerItem, {
      key: treeNode.id || i,
      treeNode: treeNode,
      measureRef: measureRef,
      onExpand: onExpand,
      onSelect: onSelect,
      close: close,
      hashTable: hashTable,
      expanded: expanded,
      selected: selected,
      setExpanded: setExpanded,
      setSelected: setSelected
    });
  })));
};
Explorer.propTypes = {
  treeNodes: PropTypes.array,
  onExpand: PropTypes.func,
  onSelect: PropTypes.func,
  expandedKeys: PropTypes.array,
  selectedKeys: PropTypes.array,
  groupTitle: PropTypes.string,
  entityTitle: PropTypes.string,
  baseLabel: PropTypes.string,
  loading: PropTypes.bool,
  infLoading: PropTypes.bool,
  loadMore: PropTypes.func,
  emptyListCallback: PropTypes.func,
  close: PropTypes.func,
  navigatorBar: PropTypes.object,
  infiniteLoading: PropTypes.shape({
    loadMore: PropTypes.func,
    ids: PropTypes.array,
    levels: PropTypes.array,
    loading: PropTypes.bool,
    observerOptions: PropTypes.object
  })
};
export default Explorer;